// AverageDailyIncrease.js
import { useState, useEffect } from 'react';
import { chakra } from '@chakra-ui/react';
import { calculateAverageDailyIncrease, formatNumber } from '../../utils/helper';



// Component to display the average daily increase
const AverageDailyIncrease = ({ data }) => {
	const [averageIncrease, setAverageIncrease] = useState(null);

	useEffect(() => {
		try {
			const result = calculateAverageDailyIncrease(data);
			setAverageIncrease(result);
		} catch (error) {
			console.error(error);
			setAverageIncrease(null);
		}
	}, [data]);

	return (
		averageIncrease !== null && (
			<chakra.span color="#FF684B" fontWeight={"bold"} fontSize={"24px"}>
				{formatNumber(averageIncrease.toFixed(2))}
			</chakra.span>
		)
	);
};

export default AverageDailyIncrease;
